import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { updateCacheByType } from '../../../graphql/GraphQlProvider';
import { Group } from '../../../graphql/groups.datatypes';
import { gqlGroup } from '../getGroup.api';

interface CloneGroupVars {
  id: number,
}

interface CloneGroupData {
  cloneGroup: Group
}

export const CLONE_GROUP_MUTATION = gql`
    mutation cloneGroup($id: Int!){
        cloneGroup(id: $id){
          ${gqlGroup}
        }
    }
`;

export const cloneGroup = () => useMutation<CloneGroupData, CloneGroupVars>(
  CLONE_GROUP_MUTATION,
  {
    update: updateCacheByType('Group'),
  }
);

export default cloneGroup;